import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "tabButton", "frame", "dot"];

  frameTargetConnected(frame) {
    if (this.#isVisible(frame)) {
      this.#loadFrame(frame);
    }
  }

  showTab(event) {
    const tab = event.currentTarget.dataset.tab;
    this.tabTargets.forEach((el) => {
      el.hidden = el.dataset.tab !== tab;
    });
    this.tabButtonTargets.forEach((btn) => {
      btn.classList.toggle("active", btn.dataset.tab === tab);
    });
    this.#loadVisibleFrame();
  }

  showStep(event) {
    const { tab, step } = event.currentTarget.dataset;
    this.frameTargets
      .filter((f) => f.dataset.tab === tab)
      .forEach((f) => {
        f.hidden = f.dataset.step !== step;
      });
    this.dotTargets
      .filter((d) => d.dataset.tab === tab)
      .forEach((d) => {
        d.classList.toggle("active", d.dataset.step === step);
      });
    this.#loadVisibleFrame();
  }

  #loadVisibleFrame() {
    const frame = this.frameTargets.find((f) => this.#isVisible(f));
    if (frame) this.#loadFrame(frame);
  }

  #loadFrame(frame) {
    const iframe = frame.querySelector("iframe[data-src]");
    if (iframe && !iframe.src) {
      iframe.src = iframe.dataset.src;
    }
  }

  #isVisible(element) {
    if (element.offsetParent === null) return false;
    let el = element;
    while (el) {
      if (el.hidden) return false;
      el = el.parentElement;
    }
    return true;
  }
}
